<template>
  <div>
    <!-- Menu Superior -->
    <div class="theme-hero-area theme-hero-area-primary">
      <div class="theme-hero-area-bg-wrap">
        <div
          class="theme-hero-area-bg ws-action"
          :style="{'background-image': 'url(' + require('@/assets/img/bg-home-car.jpg') + ')'}"
          data-parallax="true"
        ></div>
        <div class="theme-hero-area-mask theme-hero-area-mask-strong"></div>
      </div>
      <div class="theme-hero-area-body">
        <div class="container">
          <div class="theme-search-area theme-search-area-white mt-90 mb-20">
            <div class="row">
              <div class="col-md-12">
                <box-search ref="boxsearch" :flight="flight"></box-search>
              </div>
              <div class="col-md-12 mt-30">
                <div class="theme-search-area-header theme-search-area-header-sm">
                  <div class="visible-xs">
                  <h1 class="theme-search-area-title">{{total_results}} Veículos Encontrados</h1>
                  <p class="theme-search-area-subtitle">
                    <i class="fa fa-calendar-check-o"></i>
                    &nbsp;Retirada: {{start_date | datetimeToHuman}}
                  </p>
                  <p class="theme-search-area-subtitle">
                    <i class="fa fa-calendar-check-o"></i>
                    &nbsp;Devolução: {{end_date | datetimeToHuman}}
                  </p>
                  </div>
                  <div class="hidden-xs">
                    <p class="theme-search-area-subtitle">
                      <strong>{{total_results}}</strong> Veículos Encontrados &nbsp;&nbsp;|&nbsp;&nbsp;
                      <strong>
                        <i class="fa fa-calendar-check-o"></i>&nbsp;Retirada:
                      </strong>
                      {{start_date | datetimeToHuman}}&nbsp;&nbsp;
                      <i class="fa fa-arrows-h"></i>&nbsp;&nbsp;
                      <strong>
                        <i class="fa fa-calendar-check-o"></i>&nbsp;Devolução:
                      </strong>
                      {{end_date | datetimeToHuman}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Menu Superior -->
    <!-- Conteudo -->
    <div class="theme-page-section theme-page-section-gray">
      <div class="container">
        <div class="row row-col-static" id="sticky-parent" data-gutter="20">
          <div class="col-md-3">
            <div class="sticky-col _mob-h">
              <div class="theme-search-results-sidebar">
                <div
                  class="theme-search-results-sidebar-sections _mb-20 _br-2 _b-n theme-search-results-sidebar-sections-white-wrap"
                >
                  <div class="theme-search-results-sidebar-section">
                    <h5 class="theme-search-results-sidebar-section-title">Preço</h5>
                    <div class="theme-search-results-sidebar-section-price _mb-15">
                      <vue-slider
                        v-model="filter.price"
                        ref="slider"
                        :min="0"
                        :max="Math.ceil(this.max_total_rate * 1.2)"
                        :tooltipDir="['bottom', 'bottom']"
                        :formatter="'R$ {value}'"
                        :speed="1"
                      ></vue-slider>
                    </div>
                  </div>

                  <div class="theme-search-results-sidebar-section" v-if="providers">
                    <h5 class="theme-search-results-sidebar-section-title">Locadoras</h5>
                    <div class="theme-search-results-sidebar-section-checkbox-list">
                      <div class="theme-search-results-sidebar-section-checkbox-list-items">
                        <div>
                          <p-check
                            class="p-svg p-default p-fill p-smooth mt-10"
                            color="primary"
                            type="checkbox"
                            v-for="provider in Object.keys(groupedByProvider)"
                            :key="provider"
                            v-on:change="setProviderFilter(provider)"
                            style="display: block"
                          >
                            <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                              <path
                                d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                style="stroke: white;fill:white"
                              ></path>
                            </svg>
                            <span class="pretty-space">{{provider}} ({{groupedByProvider[provider].length}})</span>
                          </p-check>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="theme-search-results-sidebar-section" v-if="groups">
                    <h5 class="theme-search-results-sidebar-section-title">Categoria</h5>
                    <div class="theme-search-results-sidebar-section-checkbox-list">
                      <div class="theme-search-results-sidebar-section-checkbox-list-items">
                        <div>
                          <p-check
                            class="p-svg p-default p-fill p-smooth mt-10"
                            color="primary"
                            type="checkbox"
                            v-for="group in Object.keys(groupedByGroup)"
                            :key="group"
                            v-on:change="setGroupFilter(group)"
                            style="display: block"
                          >
                            <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                              <path
                                d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                style="stroke: white;fill:white"
                              ></path>
                            </svg>
                            <span class="pretty-space">{{group}} ({{ groupedByGroup[group].length }})</span>
                          </p-check>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="theme-ad">
                <a class="theme-ad-link" href="#"></a>
                <p class="theme-ad-sign">Propaganda</p>
                <img
                  class="theme-ad-img"
                  src="@/assets/img/banner-gol.png"
                  alt="Tarifas imperdiveis para seu destino"
                  title="Propaganda"
                >
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <div class="theme-search-results">

              <!-- item car -->
              <template v-if="!results.length && loading==false">
                <div class="theme-search-results-item theme-search-results-item-">
                  <div class="theme-search-results-item-preview">
                    Nenhum carro encontrado. Por favor refaça sua busca.
                  </div>
                </div>
              </template>
              <div
                class="theme-search-results-item _mb-10 _b-n theme-search-results-item-rounded theme-search-results-item-"
                v-for="item in filteredCars(results)" v-else
                :key="item.vehicle.id"
              >
                <div class="theme-search-results-item-preview">
                  <div class="row" data-gutter="20">
                    <div class="col-md-3">
                      <div class="theme-search-results-item-img-wrap">
                        <img
                          class="theme-search-results-item-img"
                          v-bind:src="item.vehicle.image_url"
                          v-bind:alt="item.vehicle.description"
                        >
                        <p class="theme-search-results-item-price-sign text-center mt-20">{{item.vehicle.description}}</p>
                      </div>
                      <ul class="theme-search-results-item-car-feature-list mb-10">
                        <li>
                          <i class="fa fa-male" title="Ocupantes"></i>
                          <span>{{item.vehicle.passengers || 0}}</span>
                        </li>
                        <li>
                          <i class="fa fa-cog" title="Câmbio"></i>
                          <span>{{item.vehicle.transmission}}</span>
                        </li>
                        <li v-if="item.vehicle.air_conditioner">
                          <i class="fa fa-snowflake-o" title="Ar-condicionado"></i>
                          <span>A/C</span>
                        </li>
                        <li>
                          <i class="fa fa-car" title="Portas"></i>
                          <span>{{item.vehicle.doors}} portas</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-7">
                      <h5
                        class="theme-search-results-item-title _fw-b _mb-20 _fs theme-search-results-item-title-lg"
                      >{{item.vehicle.model}}</h5>
                      <ul class="theme-search-results-item-car-list">
                        <li>
                          <i class="fa fa-check"></i>Retirada e devolução com tanque abastecido
                        </li>
                        <li>
                          <i v-if="item.vehicle.rate.distance.unlimited === true" class="fa fa-check"></i>
                          <i v-else class="fa fa-times" style="color: red; width: 12px;"></i>Quilometragem ilimitada
                        </li>
                        <li v-if="item.vehicle.rate.distance.unlimited === false" >
                          <i class="fa fa-check"></i>Franquia mensal: 1000 km
                        </li>
                        <li>
                          <i class="fa fa-check"></i>Cancelamento gratuito
                        </li>
                      </ul>

                      <div class="col-md-12">
                      <div class="theme-search-results-item-car-location mt-20">
                        <i
                          class="fa fa-calendar-check-o theme-search-results-item-car-location-icon"
                          title="Retirada"
                        ></i>
                        <div class="theme-search-results-item-car-location-body">
                          <p class="theme-search-results-item-car-location-subtitle">Retirada</p>
                          <p class="theme-search-results-item-car-location-title">
                            {{item.vehicle.pickup_agency.name}}<br />
                            {{item.vehicle.pickup_agency.address}}<br />
                          </p>
                        </div>
                      </div>
                      <div class="theme-search-results-item-car-location">
                        <i
                          class="fa fa-calendar-check-o theme-search-results-item-car-location-icon"
                          title="Devolução"
                        ></i>
                        <div class="theme-search-results-item-car-location-body">
                          <p class="theme-search-results-item-car-location-subtitle">Devolução</p>
                          <p class="theme-search-results-item-car-location-title">
                            {{item.vehicle.delivery_agency.name}}<br />
                            {{item.vehicle.delivery_agency.address}}<br />
                          </p>
                        </div>
                      </div>
                    </div>
                    </div>

                    <div class="col-md-2">
                      <div class="theme-search-results-item-book">
                        <span class="center-block mt-5 _mb-70">
                          <img
                            class="img-responsive"
                            :src="require('@/assets/img/logo-' + item.provider.toLowerCase() + '.svg')"
                            :alt="item.provider.toLowerCase()"
                            :title="item.provider">
                        </span>
                      </div>
                      <div class="theme-search-results-item-book _mt-50">
                        <div class="theme-search-results-item-price">
                          <p class="theme-search-results-item-car-location-subtitle">Diária</p>
                          <p class="theme-search-results-item-price-tag">{{item.day_rate | brlPrice}}</p>
                        </div>
                        <router-link :to="{name: 'cardetails', params: { hash: request.hash, vehicle_id: item.vehicle.id }}"
                          class="btn btn-primary btn-block theme-search-results-item-price-btn"
                        >Selecionar</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- /Conteudo -->
    <lockscreen :loading="loading"></lockscreen>
  </div>
</template>

<script>
import BoxSearch from "../../components/template/boxsearch.vue";
import lockscreen from "../../components/lockscreen/index";
import spinner from "../../components/spinner/plane-spinner.vue";
import vueSlider from "vue-slider-component";
import flights from "../../mixins/flights";
import travelers from "../../mixins/travelers";


export default {
  data(){
    return {
      pickup_location: null,
      delivery_location: null,
      start_date: null,
      end_date: null,
      km_option: null,
      results: [],
      groups: [],
      providers: [],
      next: null,
      loading: false,
      request: null,
      total_results: 0,
      max_total_rate: 10000,
      filter: {
        price: [0, 10000],
        groups: [],
        providers: []
      },
    }
  },
  components: {
    lockscreen,
    spinner,
    vueSlider,
    BoxSearch
  },
  mixins: [flights, travelers],
  methods: {
    changeData() {
      this.pickup_location = this.$route.params.pickup_location;
      this.delivery_location = this.$route.params.delivery_location;
      this.start_date = this.$route.params.datetime_start;
      this.end_date = this.$route.params.datetime_end;
      this.total_results = 0
    },
    fetchData() {
      this.loading = true;
      this.changeData();

      let url = `/api/vehicle/availability/`;

      this.$http({
        url: url,
        method: "GET",
        params: {
          pickup_location: this.pickup_location,
          delivery_location: this.delivery_location,
          start_date: this.start_date,
          end_date: this.end_date,
        }
      }).then(response => {
        if (response.data.results.length){
          this.results = response.data.results;
          this.groups = response.data.groups;
          this.providers = response.data.providers;
          this.next = response.next;
          this.total_results = response.data.total_results;
          this.max_total_rate = this.results[this.results.length - 1].total_rate;
          this.filter.price = [0, Math.ceil(this.max_total_rate)]
          this.request = response.data.request;
        } else {
          this.results = [];
        }
        this.loading = false;
      });
    },
    filteredCars(items) {
      return items.filter(item => {
        let response = true;
        if( item.total_rate >= this.filter.price[0] && item.total_rate <= this.filter.price[1]){

          if (this.filter.providers.length && this.filter.groups.length){
            response = this.filter.providers.includes(item.vehicle.provider) && this.filter.groups.includes(item.vehicle.description);
          }
          else if (this.filter.providers.length && !this.filter.groups.length){
            response = this.filter.providers.includes(item.vehicle.provider);
          }
          else if (!this.filter.providers.length && this.filter.groups.length){
            response = this.filter.groups.includes(item.vehicle.description);
          }
        } else {
          response = false;
        }
        return response
      });
    },
    setGroupFilter(group){
      if (this.filter.groups.includes(group)){
        this.filter.groups.splice(this.filter.groups.indexOf(group), 1)
      } else {
        this.filter.groups.push(group)
      }
    },
    setProviderFilter(provider){
      if (this.filter.providers.includes(provider)){
        this.filter.providers.splice(this.filter.providers.indexOf(provider), 1)
      } else {
        this.filter.providers.push(provider)
      }

    }
  },
  computed: {
    groupedByProvider() {
      const grouped = {};
      this.results.forEach(item => {
        if (!grouped[item.provider]) {
          grouped[item.provider] = [];
        }
        grouped[item.provider].push(item);
      });
      return grouped;
    },
    groupedByGroup() {
      const grouped = {};
      if(this.filter.providers.length < 1){
        this.results.forEach(item => {
          if (!grouped[item.vehicle.description]) {
            grouped[item.vehicle.description] = [];
          }
          grouped[item.vehicle.description].push(item);
        });
        return grouped;
      }
      this.results.forEach(item => {
        if(this.filter.providers.includes(item.provider)) {
          if (!grouped[item.vehicle.description]) {
            grouped[item.vehicle.description] = [];
          }
          grouped[item.vehicle.description].push(item);
        }
      });
      return grouped;
    }
  },
  mounted() {
    this.fetchData();
    $("#price-slider").ionRangeSlider({
      type: "double",
      prefix: "$"
    });

    $("#price-slider-mob").ionRangeSlider({
      type: "double",
      prefix: "$"
    });
  },
  created() {
    this.$ga.page('/');
  },
  watch: {
    $route(to, from) {
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.theme-search-area-header-sm .theme-search-area-subtitle {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 100;
  opacity: 1;
}
.theme-search-results-sort-title {
  font-size: 13px;
  margin: 0;
  margin-right: 14px;
  margin-left: 14px;
  float: left;
  font-weight: 400;
  letter-spacing: 0;
  color: #4c4c4c;
}
.theme-sidebar-section-charges-item-price {
  position: relative;
  top: 0;
  right: 0;
  font-size: 13px;
  font-weight: bold;
  line-height: 1em;
  text-align: right;
}
.theme-search-results-item-flight-details-schedule-dots-fares {
  width: 100%;
  border-top: 2px dotted #000;
  opacity: 0.1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=10)";
  filter: alpha(opacity=10);
}
.pb-lr-5 {
  padding-left: 5px;
  padding-right: 5px;
}
.theme-search-results-sort-list li {
  float: left;
  border-left: 0;
}
.theme-search-results-sort-list li:last-child {
  border-right: 0;
}
.theme-search-results-item-flight-section-airline-title {
  font-size: 12px;
  font-weight: bold;
}
.theme-search-results-sort-title {
  font-size: 13px;
  margin: 0;
  margin-right: 0;
  margin-left: 0;
  float: left;
  font-weight: 400;
  letter-spacing: 0;
  color: #4c4c4c;
}

@media only screen and (min-width: 320px) {
  .br-2px {
    border-bottom: 1px dashed #b3b3b3;
    border-right: 0;
  }
}
@media only screen and (min-width: 480px) {
  .br-2px {
    border-bottom: 1px dashed #b3b3b3;
    border-right: 0;
  }
}
@media only screen and (min-width: 768px) {
  .br-2px {
    border-bottom: 0;
    border-right: 1px dashed #b3b3b3;
  }
}
@media only screen and (min-width: 992px) {
  .br-2px {
    border-bottom: 0;
    border-right: 1px dashed #b3b3b3;
  }
}
@media only screen and (min-width: 1200px) {
  .br-2px {
    border-bottom: 0;
    border-right: 1px dashed #b3b3b3;
  }
}
.theme-search-results-sort-price-box {
  color: #4c4c4c;
}
.mt-60 {
  margin-top: 60px;
}
.theme-search-results-item-car-location-icon {
    display: block;
    float: left;
    font-size: 20px;
    margin-right: 10px;
    opacity: 0.75;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=75)";
    filter: alpha(opacity=75);
}
.theme-search-results-item-car-feature-list > li span {
    font-size: 12px;
    display: block;
}
</style>
